// Single source of truth for the Podcastify community (Discord).
//
// The invite URL comes from `NEXT_PUBLIC_DISCORD_INVITE_URL` — see
// `.env.example`. Never hardcode the invite in a component: import from here
// instead.

const FALLBACK_INVITE_URL = "https://discord.gg/uSxSAhcrKs";

function readEnv(raw: string | undefined, fallback: string): string {
  const value = (raw ?? "").trim();
  return value.length > 0 ? value : fallback;
}

export const DISCORD_INVITE_URL = readEnv(
  process.env.NEXT_PUBLIC_DISCORD_INVITE_URL,
  FALLBACK_INVITE_URL,
);

export const COMMUNITY_PATH = "/community";
